import React, { memo, useState } from 'react';
import QuestionsCard from '../Card/MaterEntryCards/QuestionsCard';
import QuestionsTable from '../Table/questions/QuestionsTable';

const Questions = () => {
    //#region code
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState(null);

    const handleChange = () => {
      setIsChanged(!isChanged);
    }

    const handleEdit = (params) => {
        setEditData(params)
    }    
    
    //#endregion

    return (
        <>
            <QuestionsCard isChanged={handleChange} editData={editData} setEditData={setEditData}/>
            <QuestionsTable isChanged={isChanged} handleEdit={handleEdit}/>
        </>
    )
}

export default memo(Questions);
